import React, { useState } from 'react';

const certificateOptions = [
  "Student Pilot Certificate",
  "Private Pilot Certificate",
  "Commercial Pilot Certificate",
  "Airline Transport Pilot (ATP) Certificate",
  "Recreational Pilot Certificate",
  "Sport Pilot Certificate",
  "Remote Pilot Certificate",
];

const ratingOptions = [
  "Instrument Rating",
  "Multi-Engine Rating",
  "Seaplane Rating",
  "Tailwheel Endorsement",
  "High-Altitude Endorsement",
  "Complex Aircraft Endorsement",
  "High-Performance Endorsement",
  "CFI Rating",
  "CFII Rating",
  "MEI Rating"
];

const CertificatesForm = ({ initialData = {}, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    type: initialData.type || '',
    issueDate: initialData.issueDate || '',
    ratings: initialData.ratings || [],
  });

  const handleAddRating = () => {
    setFormData((prev) => ({
      ...prev,
      ratings: [...prev.ratings, ''],
    }));
  };

  const handleUpdateRating = (index, value) => {
    const updatedRatings = [...formData.ratings];
    updatedRatings[index] = value;
    setFormData((prev) => ({
      ...prev,
      ratings: updatedRatings,
    }));
  };

  const handleRemoveRating = (index) => {
    setFormData((prev) => ({
      ...prev,
      ratings: prev.ratings.filter((_, i) => i !== index),
    }));
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(formData);
      }}
      className="space-y-4"
    >
      <div className="flex space-x-4">
        <div>
          <label className="block text-sm font-medium">Certificate Type</label>
          <select
            value={formData.type}
            onChange={(e) => setFormData({ ...formData, type: e.target.value })}
            className="w-60 px-3 py-2 border rounded-lg"
          >
            <option value="">Select Certificate Type</option>
            {certificateOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium">Issue Date</label>
          <input
            type="date"
            value={formData.issueDate}
            onChange={(e) => setFormData({ ...formData, issueDate: e.target.value })}
            className="w-60 px-3 py-2 border rounded-lg"
          />
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium">Ratings</label>
        {formData.ratings.map((rating, index) => (
          <div key={index} className="flex items-center space-x-2">
            <select
              value={rating}
              onChange={(e) => handleUpdateRating(index, e.target.value)}
              className="w-60 px-3 py-2 border rounded-lg"
            >
              <option value="">Select Rating</option>
              {ratingOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            <button
              type="button"
              onClick={() => handleRemoveRating(index)}
              className="text-red-500"
            >
              Remove
            </button>
          </div>
        ))}
        <button
          type="button"
          onClick={handleAddRating}
          className="text-blue-500"
        >
          Add Rating
        </button>
      </div>
      <div className="flex justify-end space-x-2">
        <button
          type="button"
          onClick={onCancel}
          className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-400"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
        >
          Save Certificate
        </button>
      </div>
    </form>
  );
};

export default CertificatesForm;
